module.exports = __webpack_public_path__ + "img/icon_drop-down-arrow_24.52ae63d8.svg";